import { render, staticRenderFns } from "./UpdateDictionaryForm.vue?vue&type=template&id=2c81bb96&"
import script from "./UpdateDictionaryForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateDictionaryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports